module.exports = __webpack_public_path__ + "static/media/S (190).3eeaee1c.jpg";